<template>
    <NoDataTable :is-first-load="params.isFirstLoad" />
</template>

<script>
import NoDataTable from '../../noData/NoDataTable.vue';

export default {
    name: 'NoDataTableAgGrid',
    components: {
        NoDataTable,
    },
    props: {
        params: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
